import React/* , { useCallback } */ from "react";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
// import { Popconfirm } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { /* faPowerOff, */ faPlusSquare } from "@fortawesome/free-solid-svg-icons";
import { languageGetSearch, languageDelete } from "actions/language/requests";
import CommonTable from "../../lib/components/CommonTable";

const Module = ({
                  getList,
                  // languageDelete,
                  list,
                  // ...rest
                }) => {
  /* const handleDelete = useCallback((ev, id) => {
    ev.preventDefault();
    languageDelete(id);
  }, [languageDelete]); */

  const getColumns = () => [
    {
      id: "id",
      Header: "ISO/ID",
      accessor: "id",
    },
    {
      id: "name",
      Header: "Name",
      accessor: "name",
    },
    {
      id: "flag",
      Header: "Flag",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (original.flag ? (
        <img
          src={original.flag}
          alt={original.name}
          title={original.name}
          className="img-thumbnail"
          style={{
            maxHeight: 32,
            width: "auto"
          }}
        />
      ) : null)
    },
    {
      id: "actions",
      Header: "Actions",
      className: "text-center",
      headerClassName: "text-center",
      // eslint-disable-next-line react/display-name
      Cell: (/* { original } */) => (
        <React.Fragment>
          {/* <Link to={`/language/edit/${original.id}`}
                className="btn btn-sm mx-2 btn-warning">
            <FontAwesomeIcon icon={faPencilAlt}/>
          </Link> */}
          {/* <Popconfirm
            title="Are you sure?"
            onConfirm={ev => handleDelete(ev, original.id)}
            placement="bottomRight"
            okText="Yes"
            cancelText="Cancel"
          >
            <button className="btn btn-sm btn-danger" type="button">
              <FontAwesomeIcon icon={faPowerOff} />
            </button>
          </Popconfirm> */}
        </React.Fragment>
      )
    },
  ];

  return (
    <CommonTable
      columns={getColumns()}
      list={list}
      getListFunction={getList}
      FiltersComponent={() => (
        <div className="d-flex justify-content-between align-items-center">
          <h1>Languages</h1>
          <Link to="/language/create" className="btn btn-success">
            <FontAwesomeIcon icon={faPlusSquare} title="Create New"/>
          </Link>
        </div>
      )}
      searchHookProps={{
        size: 20,
        sort: "id,asc"
      }}
    />
  );
};

const mapStateToProps = state => ({
  loading: state.language.loading,
  list: state.language.list
});

const mapStateToDispatch = dispatch => ({
  getList: bindActionCreators(languageGetSearch, dispatch),
  languageDelete: bindActionCreators(languageDelete, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(Module);



// WEBPACK FOOTER //
// ./src/views/pages/Language/index.js